import React from 'react';

export default function ActivityCardSkeleton({ variant = 'default' }) {
  if (variant === 'compact') {
    return (
      <div className="overflow-hidden rounded-xl border-0">
        <div className="flex gap-4 p-4">
          <div className="relative w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden shimmer" />
          <div className="flex-1 min-w-0 space-y-2 py-1">
            <div className="h-4 rounded shimmer w-3/4" />
            <div className="h-3 rounded shimmer w-full" />
            <div className="h-3 rounded shimmer w-2/3" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border-0">
      {/* Image area — same aspect ratio as real card */}
      <div className="relative aspect-[16/9] rounded-lg overflow-hidden shimmer" />
      {/* Text area */}
      <div className="py-4 space-y-2">
        <div className="h-5 rounded shimmer w-3/4" />
        <div className="h-3 rounded shimmer w-full" />
        <div className="h-3 rounded shimmer w-5/6" />
        <div className="h-3 rounded shimmer w-1/3 mt-3" />
      </div>
    </div>
  );
}